/* YouTubeIframe.tsx generated by @compiled/babel-plugin v0.36.0 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { LiteYoutubeEmbed } from 'react-lite-yt-embed';
import { TEST_ID } from '../constants';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const _7 = "._1jpx1dfr img{object-fit:cover}";
const _6 = "._bfhkn82g{background-color:var(--ds-skeleton,#091e420f)}";
const _5 = "._kqswh2mm{position:relative}";
const _4 = "._2rkoftgi{border-radius:8px}";
const _3 = "._19itpp12{border:var(--_18x9sjc)}";
const _2 = "._18m915vq{overflow-y:hidden}";
const _ = "._1reo15vq{overflow-x:hidden}";
const YouTubeEmbedContainer = null;
export const YouTubeIframe = _ref => {
  let {
    youtubeId,
    imageAltText
  } = _ref;
  return (
    /*#__PURE__*/
    // Extra div is here is necessary for intrinsic aspect ratio to work
    _jsx("div", {
      children: /*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_, _2, _3, _4, _5, _6, _7]
        }), /*#__PURE__*/_jsx("div", {
          "data-testid": TEST_ID.OVERVIEW_TAB_YOUTUBE_IFRAME,
          className: ax(["_1reo15vq _18m915vq _19itpp12 _2rkoftgi _kqswh2mm _bfhkn82g _1jpx1dfr"]),
          style: {
            "--_18x9sjc": ix("1px solid ".concat("var(--ds-border, #091E4224)"))
          },
          children: /*#__PURE__*/_jsx(LiteYoutubeEmbed, {
            // Adding a key prop to force remount the LiteYoutubeEmbed component.
            id: youtubeId,
            imageAltText: imageAltText,
            mobileResolution: "hqdefault",
            desktopResolution: "hqdefault"
          }, youtubeId)
        })]
      })
    })
  );
};